import { render, staticRenderFns } from "./list.vue?vue&type=template&id=750dd4bf&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=750dd4bf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750dd4bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('750dd4bf')) {
      api.createRecord('750dd4bf', component.options)
    } else {
      api.reload('750dd4bf', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=750dd4bf&scoped=true", function () {
      api.rerender('750dd4bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/resource/list.vue"
export default component.exports